import { render, staticRenderFns } from "./WikiProposalsCore.vue?vue&type=template&id=555e3e6c&"
import script from "./WikiProposalsCore.vue?vue&type=script&lang=js&"
export * from "./WikiProposalsCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports